import React, { createContext, useContext, useState } from 'react';

const EC2LoadingContext = createContext();

export const useEC2Loading = () => {
  const context = useContext(EC2LoadingContext);
  if (!context) {
    throw new Error('useEC2Loading must be used within an EC2LoadingProvider');
  }
  return context;
};

export const EC2LoadingProvider = ({ children }) => {
  // Store loading states for multiple projects
  const [loadingStates, setLoadingStates] = useState({});

  const startLoading = (projectId, projectName) => {
    setLoadingStates(prev => ({
      ...prev,
      [projectId]: {
        isLoading: true,
        projectName: projectName || `Project ${projectId}`,
        startTime: Date.now()
      }
    }));
  };

  const stopLoading = (projectId) => {
    setLoadingStates(prev => {
      const newStates = { ...prev };
      delete newStates[projectId];
      return newStates;
    });
  };

  const isProjectLoading = (projectId) => {
    return loadingStates[projectId]?.isLoading || false;
  };

  const getLoadingProject = (projectId) => {
    return loadingStates[projectId];
  };

  const getAllLoadingProjects = () => {
    return Object.keys(loadingStates).map(projectId => ({
      projectId,
      ...loadingStates[projectId]
    }));
  };

  const value = {
    loadingStates,
    startLoading,
    stopLoading,
    isProjectLoading,
    getLoadingProject,
    getAllLoadingProjects
  };

  return (
    <EC2LoadingContext.Provider value={value}>
      {children}
    </EC2LoadingContext.Provider>
  );
};
